import { IDetailPageData } from "../../../shared/utils/api";

export interface ICustomSearchField {
  id: string;
  model_type: string;
  model_id?: string;
  field_name?: string;
  field_id?: string;
  field_type?: string;
}

export interface ICustomSearchFieldsBackendType {
  custom_search_fields: ICustomSearchField[];
}

export function transformToBackendCustomSearchFields(data: IDetailPageData): ICustomSearchFieldsBackendType | undefined {
  if (!data.rowData || data.rowData.length === 0) {
    return;
  }

  return {
    custom_search_fields: data.rowData.map(field => ({
      id: field.id,
      model_type: field.model_type,
      model_id: field.model_id,
      field_name: field.field_name,
      field_id: field.field_id,
      field_type: field.field_type
    }))
  };
}

export function transformFromBackendCustomSearchFields(backendType: ICustomSearchField[]): IDetailPageData {
  return {
    rowData: backendType.map(field => ({
      id: field.id,
      model_type: field.model_type,
      model_id: field.model_id,
      field_name: field.field_name,
      field_id: field.field_id,
      field_type: field.field_type
    }))
  };
}